<template>
  <g fill-rule="evenodd">
    <path
      d="M16.95 10.67A2.75 2.75 0 0015.63 14l.04.16a1.22 1.22 0 01-1.52 1.52l-.16-.04a2.84 2.84 0 00-3.32 1.32 1.2 1.2 0 01-2.12 0 2.78 2.78 0 00-2.48-1.48c-.28 0-.56.04-.84.12l-.16.04a1.21 1.21 0 01-1.52-1.52L3.6 14a2.84 2.84 0 00-1.32-3.32 1.2 1.2 0 010-2.12A2.84 2.84 0 003.6 5.23l-.04-.16a1.21 1.21 0 011.52-1.52l.16.04c1.28.4 2.68-.16 3.32-1.32a1.2 1.2 0 012.12 0A2.81 2.81 0 0014 3.63l.16-.04a1.22 1.22 0 011.52 1.52l-.04.08a2.84 2.84 0 001.32 3.32c.6.32.8 1.08.48 1.64a.88.88 0 01-.48.52m.76-3.56a1.17 1.17 0 01-.56-1.44l.04-.16A2.78 2.78 0 0015.4 2c-.56-.2-1.16-.2-1.72 0l-.16.04c-.56.2-1.16-.08-1.44-.56a2.83 2.83 0 00-4.96 0c-.28.52-.88.76-1.44.56L5.51 2A2.78 2.78 0 002 3.8c-.2.56-.2 1.16 0 1.72l.04.16c.2.56-.08 1.16-.56 1.44a2.83 2.83 0 000 4.96c.52.28.76.88.56 1.44l-.04.16a2.78 2.78 0 001.8 3.52c.56.2 1.16.2 1.72 0l.16-.04c.56-.2 1.16.08 1.44.56a2.83 2.83 0 004.96 0c.28-.52.88-.76 1.44-.56l.16.04a2.78 2.78 0 003.52-1.8c.2-.56.2-1.16 0-1.72l-.04-.16c-.2-.56.08-1.16.56-1.44a2.83 2.83 0 000-4.96"
    />
    <path
      d="M12.55 6.63a.77.77 0 00-1.12 0l-4.8 4.8a.81.81 0 00-.08 1.12c.28.32.8.36 1.12.08.04-.04.08-.04.08-.08l4.8-4.8a.77.77 0 000-1.12M8 7.6c0-.69-.53-1.2-1.2-1.2-.69 0-1.2.51-1.2 1.2 0 .67.51 1.2 1.2 1.2.67 0 1.2-.53 1.2-1.2M12.4 10.4c-.69 0-1.2.51-1.2 1.2 0 .67.51 1.2 1.2 1.2.67 0 1.2-.53 1.2-1.2 0-.69-.53-1.2-1.2-1.2"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LiveOpsIcon",
});
</script>
